import {
  RESET_PREDEFINED_MESSAGES,
  RESET_PREDEFINED_MESSAGE,
  RESET_ERROR,
  GET_PREDEFINED_MESSAGES,
  SET_PREDEFINED_MESSAGES,
  API_ERROR,
  GET_PREDEFINED_MESSAGE,
  SET_PREDEFINED_MESSAGE,
  CREATE_PREDEFINED_MESSAGE,
  CREATE_PREDEFINED_MESSAGE_SUCCESS,
  EDIT_PREDEFINED_MESSAGE,
  EDIT_PREDEFINED_MESSAGE_SUCCESS,
  DELETE_PREDEFINED_MESSAGE,
  DELETE_PREDEFINED_MESSAGE_SUCCESS,
  GET_PREDEFINED_MESSAGES_CONVERSATION,
  GET_PREDEFINED_MESSAGES_CONVERSATION_SUCCESS,
  GET_PREDEFINED_MESSAGES_CONVERSATION_ERROR,
} from "./actionTypes";

export const resetPredefinedMessages = () => {
  return {
    type: RESET_PREDEFINED_MESSAGES,
    payload: {},
  };
};

export const resetPredefinedMessage = () => {
  return {
    type: RESET_PREDEFINED_MESSAGE,
    payload: {},
  };
};

export const resetError = () => {
  return {
    type: RESET_ERROR,
    payload: {},
  };
};

export const getPredefinedMessages = (page, qnt, name, skillId) => {
  return {
    type: GET_PREDEFINED_MESSAGES,
    payload: { page, qnt, name, skillId },
  };
};

export const setPredefinedMessages = (data, qtdDefault) => {
  const maxPage = Math.ceil(data.total / qtdDefault);
  var paging = Array.from({ length: maxPage }, (v, k) => k + 1);

  return {
    type: SET_PREDEFINED_MESSAGES,
    payload: { ...data, paging },
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const createPredefinedMessage = (newPredefinedMessageValues) => {
  return {
    type: CREATE_PREDEFINED_MESSAGE,
    payload: { newPredefinedMessageValues },
  };
};
export const createPredefinedMessageSuccess = (message) => {
  return {
    type: CREATE_PREDEFINED_MESSAGE_SUCCESS,
    payload: { message },
  };
};

export const getPredefinedMessage = (idPredefinedMessage, isForm) => {
  return {
    type: GET_PREDEFINED_MESSAGE,
    payload: { idPredefinedMessage, isForm },
  };
};
export const setPredefinedMessage = (data) => {
  return {
    type: SET_PREDEFINED_MESSAGE,
    payload: { data },
  };
};

export const editPredefinedMessage = (
  idPredefinedMessage,
  newPredefinedMessageValues
) => {
  return {
    type: EDIT_PREDEFINED_MESSAGE,
    payload: { idPredefinedMessage, newPredefinedMessageValues },
  };
};
export const editPredefinedMessageSuccess = (message) => {
  return {
    type: EDIT_PREDEFINED_MESSAGE_SUCCESS,
    payload: { message },
  };
};

export const deletePredefinedMessage = (idPredefinedMessage) => {
  return {
    type: DELETE_PREDEFINED_MESSAGE,
    payload: { idPredefinedMessage },
  };
};
export const deletePredefinedMessageSuccess = (message) => {
  return {
    type: DELETE_PREDEFINED_MESSAGE_SUCCESS,
    payload: { message },
  };
};

export const getPredefinedMessagesConversation = (skillId = null) => {
  return {
    type: GET_PREDEFINED_MESSAGES_CONVERSATION,
    payload: { skillId },
  };
}

export const getPredefinedMessagesConversationSuccess = (skillId, data) => {
  return {
    type: GET_PREDEFINED_MESSAGES_CONVERSATION_SUCCESS,
    payload: { data, skillId },
  };
}

export const getPredefinedMessagesConversationError = (skillId,error) => {
  return {
    type: GET_PREDEFINED_MESSAGES_CONVERSATION_ERROR,
    payload: { error, skillId },
  };
}
